import ready from '../components/_ready';
import { mapPointCenter} from './_helper';
import { Loader as loaderGoogle } from 'google-maps';

const elementPoints = '.js--points';
const elementCoordinates = '.js--coordinates';
const elementCenter = '.js--center';
let minZoom = 6;
let maxZoom = 17;
let viewportMarkers = [];
let map = null;
let selectedValue = '';

const options = {
  version: 'weekly',
  libraries: ['places', 'directions'],
  region: 'PT',
  language: document.documentElement.lang
}

// eslint-disable-next-line no-undef
const gmapsApi = process.env.GOOGLE_MAPS_API_KEY;
const loader = new loaderGoogle(gmapsApi, options);

loader
  .load()
  .then((google) => {
    const dataPoints = document.querySelector(elementPoints);
    const centerCoordinates = document.querySelector(elementCenter) ;
    centerCoordinates.value = centerCoordinates.getAttribute('value');
    const textMaps = dataPoints.getAttribute('data-text') ?? '';

    const points = dataPoints ? JSON.parse(dataPoints.getAttribute('data-points')) ?? '' : '';
    const centerMap = mapPointCenter(dataPoints, centerCoordinates, points);
    const zoomMap = minZoom;
    const infoWindow = new google.maps.InfoWindow();

    const directionsRenderer = new google.maps.DirectionsRenderer();
    map = new google.maps.Map(document.getElementById('map_canvas'), {
      center: centerMap,
      zoom: zoomMap,
    });

    if (dataPoints) {
      if(points != []) {
        for (let i=0; i < points.length; i++) {
          if(points[i].lat != 0 && points[i].lng != 0) {
            const marker = new google.maps.Marker({
              position:  new google.maps.LatLng(points[i].lat, points[i].lng),
              icon: points[i].icon,
              title: points[i].title + ' - ' + points[i].address});
              (function(index, selectedMarker){
                google.maps.event.addListener(selectedMarker, 'click', function() {
                  if (infoWindow != null) infoWindow.setMap(null);
                  infoWindow.setContent(`
                  <h4 class="text-tertiary pb-2 font-family-base">${points[index].title}</h4>
                  <div class="font-family-base caption text-muted">${points[index].address}</div>
                  <div class="font-family-base text-right pt-2 mt-1">
                    <a class="caption" href="https://maps.google.com/maps?ll=${points[index].coordinates}" target="_blank">${textMaps}</a>
                  </div>
                  `);
                  infoWindow.open(map, selectedMarker);
                });
              })(i, marker);
            marker.setMap(map);
            viewportMarkers.push(marker);
          }
        }
      }
    }
    directionsRenderer.setMap(map);
  });

  function addClass(element, targetClass) {
    element.classList.add(targetClass);
  }

  function removeClass(element, targetClass) {
    element.classList.remove(targetClass);
  }

ready(() => {

  const selectedCoordinates = document.querySelectorAll(elementCoordinates);
  selectedCoordinates.forEach(element  => {
    let coordinatesValue = element.getAttribute('value');
    if (coordinatesValue != undefined && coordinatesValue != '') {
      element.value = coordinatesValue;
      element.addEventListener('click',function(){
        loader
        .load()
        .then(() => {
          const dataPoints = document.querySelector(elementPoints);
          const points = dataPoints ? JSON.parse(dataPoints.getAttribute('data-points')) ?? '' : '';
          const centerMap = mapPointCenter(dataPoints, element, points);

          map.setZoom(maxZoom);
          map.panTo(centerMap);
        });
      });
    }
  });

  const cityValue = document.querySelector('.js--selected-city');
  const cities = document.querySelectorAll('.js--city');
  const agencies = document.querySelectorAll('.js--agency-card');
  const cityPoints = document.querySelector('.js--city-points');
  const noAgency = document.querySelector('.js--no-agency');

  cities.forEach(element => {
    element.addEventListener('click', () => {
      selectedValue = element.getAttribute('data-attribute');
      document.querySelector('.js--city.active').classList.remove('active');
      addClass(element, 'active')
      element.value = element.getAttribute('value');

      let numberAgencies = agencies.length;
      cityValue.innerText=element.innerText;
      loader
        .load()
        .then(() => {
          const points = cityPoints ? JSON.parse(cityPoints.getAttribute('data-points')) ?? '' : '';
          const centerMap = mapPointCenter(cityPoints, element, points);

          if (element.value == document.querySelector(elementCenter).getAttribute('value')) {
            map.setZoom(minZoom);
          } else{
            map.setZoom(11);
          }
          map.panTo(centerMap);
        });

      agencies.forEach(agency => {
        if(selectedValue != ''){
          if (selectedValue == '0' ){
            removeClass(agency, 'd-none');
          } else if (agency.getAttribute('data-attribute') != selectedValue) {
            addClass(agency, 'd-none')
          } else {
            removeClass(agency, 'd-none');
          }
        }
        if(agency.classList.contains('d-none')){
          numberAgencies += -1;
        }
      });

      if (numberAgencies===0) {
        removeClass(noAgency,'d-none');
      } else {
        addClass(noAgency, 'd-none');
      }
    });
  });
});
